import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// Modules
import { AdminRoutingModule } from './admin-routing.module';
import { WifiModule } from './wifi/wifi.module';
import { AdministrationModule } from './administration/administration.module';
// Interceptors
import { AuthorizationInterceptorService } from '../../interceptors/authorization-interceptor.service';
import { SvsModule } from './svs/svs.module';

@NgModule({
    declarations: [

  ],
    imports: [
        CommonModule,
        AdminRoutingModule,
        AdministrationModule,
        WifiModule,
        SvsModule
    ],
    exports: [
        AdminRoutingModule,
        AdministrationModule,
        WifiModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptorService, multi: true}
    ]
})
export class AdminModule { }
